import {
  Timestamp,
  HeaderProfileComponent,
  Description,
} from "../../components/historyRecordComponents/InfomationComponent";
import { IRecord } from "../../interfaces/record";
export default function convertDataToInfo(data: IRecord[]) {
  return data.map((item: IRecord) => [
    <HeaderProfileComponent
      pictureUrl={item.imageUrl}
      displayName={item.displayName}
      productName={item.product.productName}
      isCoupon={item.isCoupon}
    />,
    <Description summary={item.summary as string} doctorId={item.doctorId} />,
    <Timestamp time={item.timeStamp} />,
  ]);
}
